/**
 * /portal/demo — public, read-only Portal demo.
 * Anonymous visitors land here from the marketing site to see what ZeroConf
 * produces without signing up. Loads DEMO_PAYLOAD into the wizardStore and
 * forces readOnly=true. Banner CTA → /signup.
 */
import React, { useEffect, useRef } from "react";
import { Portal } from "./Portal";
import { useWizardStore } from "../zeroconf/state/wizardStore";
import { DEMO_PAYLOAD } from "../zeroconf/data/demoPayload";

export const PortalDemo = () => {
    const loadSavedConfig = useWizardStore((s) => s.loadSavedConfig);
    const fired = useRef(false);
    useEffect(() => {
        if (fired.current) return;
        fired.current = true;
        loadSavedConfig(DEMO_PAYLOAD);
        document.title = "ZeroConf — Live Demo (read-only)";
    }, [loadSavedConfig]);

    return <Portal forceReadOnly={true} forceDemo={true} />;
};

export default PortalDemo;
